import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { UserUpdate } from '../../services';

export const fetchUserUpdate = createAsyncThunk(
    'userUpdate/fetchUserUpdate',
    async ({ firstName, lastName, userName, email, phoneNumber }) => {
        const response = await UserUpdate(firstName, lastName, userName, email, phoneNumber)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const userUpdateSlice = createSlice({
    name: 'userUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUserUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchUserUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default userUpdateSlice.reducer;
